import React, { createContext, useState, useContext, useEffect } from 'react';
import { createTheme, ThemeProvider } from '@mui/material';

const ThemeContext = createContext();

export function CustomThemeProvider({ children }) {
  const [themeColors, setThemeColors] = useState({
    primary: '#1976d2',
    secondary: '#9c27b0',
    background: '#ffffff',
    text: '#000000'
  });

  useEffect(() => {
    const savedColors = localStorage.getItem('themeColors');
    if (savedColors) {
      setThemeColors(JSON.parse(savedColors));
    }
  }, []);

  const theme = createTheme({
    palette: {
      primary: {
        main: themeColors.primary,
      },
      secondary: {
        main: themeColors.secondary,
      },
      background: {
        default: themeColors.background,
        paper: themeColors.background,
      },
      text: {
        primary: themeColors.text,
      },
    },
  });

  return (
    <ThemeContext.Provider value={{ themeColors, setThemeColors }}>
      <ThemeProvider theme={theme}>
        {children}
      </ThemeProvider>
    </ThemeContext.Provider>
  );
}

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a CustomThemeProvider');
  }
  return context;
};